module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', _vm._l((_vm.discount), function(tag, index) {
    return _c('div', {
      staticClass: "recommend-fine-tips",
      on: {
        "click": function($event) {
          return _vm.goDetail(tag.url)
        }
      }
    }, [_c('div', {
      staticClass: "recommend-tip-color recommend-tip-red",
      style: ('background: ' + tag.color)
    }, [_vm._v(_vm._s(tag.tag))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(tag.title))]), _vm._v(" "), _c('img', {
      staticClass: "icon-right",
      attrs: {
        "src": require("../assets/images/icon-right.png"),
        "alt": ""
      }
    })])
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-48874fa9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/GoodsDetailTips.vue
// module id = 2343
// module chunks = 0